import BFFAPI from '../../../api/utils/BFFAPI';

class CompanyAPI extends BFFAPI {
  getCompanyAccount = () => {
    const req = this.fetchHelper.createGetRequest(this.endpoint);
    return this.fetch(req);
  };

  getCompanyDeletionRequestStatus = () => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}/company-deletion-request`);
    return this.fetch(req);
  };

  createDeletionRequest = (reason: string, contactNumber: string) => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}/company-deletion-request`, {
      reason,
      contactNumber,
    });
    return this.fetch(req);
  };

  removeCompanyDeletionRequest = () => {
    const req = this.fetchHelper.createDeleteRequest(`${this.endpoint}/company-deletion-request`);
    return this.fetch(req);
  };
}

export default new CompanyAPI('/fleet/secure/company-account');
